module.exports = __webpack_public_path__ + "img/logo.d75cf660.png";